export default "__VITE_ASSET__bfb8c5ae__"